// extracted by mini-css-extract-plugin
module.exports = {"row":"_357f39e","text":"_bfaf88a","tickIcon":"_62a3ba2"};